<header class="flux-header clearfix" [attr.nav-layout]="navLayout" [attr.navbar-type]="toggleStatus ? defaultNavbar : toggleNavbar" [attr.effect-type]="navbarEffect" [attr.header-theme]="headerColorTheme" [attr.collapsed-left-header]="collapsedLeftHeader"
        [attr.device-type]="deviceType">
  <div class="flux-header-wrapper clearfix">
    <div class="flux-brand" [attr.left-header-theme]="leftHeaderColorTheme">
      <span class="flux-brand-logo"><img src="../../../../assets/img/mafuta-logo-2.svg"  height="35" width="35"></span>
      <span class="flux-brand-text">ThunderBoltApp</span>
    </div>
    <div class="flux-header-navbar">
      <div class="flux-left-header clearfix">
        <div class="sidebarToggle" (click)="changeTheToggleStatus()"><i class="fas fa-bars"></i></div>
      </div>
      <span class="text-primo align-self-baseline mb-0 pl-2 pb-0">{{locationName.toUpperCase()}}</span>
      <div class="flux-right-header clearfix">
        <ul class="align-items-center mt-1 mx-0 px-0">
          <li><a routerLink="notifications" tooltip="Notifications" placement="bottom" aria-describedby="tooltip"><i class="fas fa-bell"></i></a></li>
          <li>
                        <span class="d-none d-lg-inline mr-0 text-gray-600 small">{{
                          userName
                          }}</span
                        ><img
            class="border rounded-circle img-profile"
            style="width: 30px; height: 30px"
            [src]="user"
          />
          </li>
          <li><a (click)="logoutUser()" tooltip="Logout"
                 placement="bottom"><i class="fas fa-power-off"></i></a></li>
          <ngx-spinner
            class="bg-warning bg-success"
            size="medium"
            type="ball-scale-multiple"
          >
            <p class="text-light">Loading...</p>
          </ngx-spinner>
        </ul>
      </div>
    </div>
  </div>
</header>
